import Vue from "vue";
import EasyTranslator from "./translator";
import { locales as appLocales } from "@/app/index";
import store from "../store";
import localforage from "@/plugins/localforage";

import en from "./en";
import hi from "./hi";

localforage.getItem("currLocale").then((val) => {
  store.dispatch("setCurrLocale", val);
});

export const getLocale = () => {
  let locale = store.getters.getCurrLocale;
  return locale;
};
export const setLocale = (locale) => {
  store.dispatch("setCurrLocale", locale);
};

let options = {
  locale: getLocale(),
  fallbackLocale: "en",
  locales: {
    en: {
      ...appLocales.en,
      ...en,
    },
    hi: {
      ...appLocales.hi,
      ...hi,
    },
  },
};

export const locales = Vue.use(EasyTranslator, options);

Vue.use(EasyTranslator, options);
